import Axios from "axios";
import { IServiceResult } from "../../../Models/IServiceResult";
import { IUser } from "../../../Models/IUser";

export const getUser = async (): Promise<IUser> => {
    const response = await Axios.get<IServiceResult<IUser>>("/Authentication/User");
    /* TODO - Add extra checks for valid response */
    return response.data.data;
};

// TODO - GB
/** This hits an endpoing that ends up running a pretty heavy query. We should create a new endpoint / proc
 * to handle and return only what we need here.
 */
export const getAllUsers = async (): Promise<IUser[]> => {
    const response = await Axios.get<IServiceResult<IUser[]>>("/Users/Listing");
    return response.data.data;
};